export const filterOperators = Object.freeze({
	None: 0,
	Equal: 1,
	NotEqual: 2,
	GreaterThan: 3,
	GreaterOrEqualThan: 4,
	LowerThan: 5,
	LowerOrEqualTahn: 6,
	Contains: 7,
	StartsWith: 8,
	IsBlank: 9,
	IsNotBlank: 10,
	IsOneOf: 11,
	IsNotOneOf: 12,
	DoesNotContain: 13,
});
